"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Transport_wire, _Transport_fin;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transport = void 0;
const events_1 = require("events");
const wire_1 = require("./wire");
const transport_errors_1 = require("./transport-errors");
const eventAggregator_1 = require("../api/events/eventAggregator");
const me_1 = require("../api/me");
const errors_1 = require("../util/errors");
class Transport extends events_1.EventEmitter {
    constructor(WireType, environment, config) {
        super();
        this.wireListeners = new Map();
        this.topicRefMap = new Map();
        this.eventAggregator = new eventAggregator_1.default();
        this.messageHandlers = [this.eventAggregator.dispatchEvent];
        _Transport_wire.set(this, void 0);
        // Typing as unknown to avoid circular dependency, should not be used directly.
        _Transport_fin.set(this, void 0);
        this.connectSync = () => {
            const wire = __classPrivateFieldGet(this, _Transport_wire, "f");
            wire.connectSync();
        };
        // This function is only used in our tests.
        this.getPort = () => {
            const wire = __classPrivateFieldGet(this, _Transport_wire, "f");
            return wire.getPort();
        };
        __classPrivateFieldSet(this, _Transport_wire, new WireType(this.onmessage.bind(this)), "f");
        this.environment = environment;
        this.sendRaw = __classPrivateFieldGet(this, _Transport_wire, "f").send.bind(__classPrivateFieldGet(this, _Transport_wire, "f"));
        this.registerMessageHandler(this.handleMessage.bind(this));
        __classPrivateFieldGet(this, _Transport_wire, "f").on('disconnected', () => {
            for (const [, { handleNack }] of this.wireListeners) {
                handleNack({ reason: 'Remote connection has closed' });
            }
            this.wireListeners.clear();
            this.emit('disconnected');
        });
        const { uuid, name } = config;
        const entityType = this.environment.getCurrentEntityType();
        this.me = (0, me_1.getBaseMe)(entityType, uuid, name);
    }
    getFin() {
        if (!__classPrivateFieldGet(this, _Transport_fin, "f")) {
            throw new Error("No Fin object registered for this transport");
        }
        return __classPrivateFieldGet(this, _Transport_fin, "f");
    }
    registerFin(_fin) {
        if (__classPrivateFieldGet(this, _Transport_fin, "f")) {
            throw new Error("Fin object has already been registered for this transport");
        }
        __classPrivateFieldSet(this, _Transport_fin, _fin, "f");
    }
    shutdown() {
        const wire = __classPrivateFieldGet(this, _Transport_wire, "f");
        return wire.shutdown();
    }
    async connect(config) {
        if ((0, wire_1.isRemoteConfig)(config)) {
            return this.connectRemote(config);
        }
        if ((0, wire_1.isExistingConnectConfig)(config)) {
            return this.connectByPort(config);
        }
        if ((0, wire_1.isNewConnectConfig)(config)) {
            const port = await this.environment.retrievePort(config);
            return this.connectByPort({ ...config, address: `ws://localhost:${port}` });
        }
        return undefined;
    }
    async connectRemote(config) {
        await __classPrivateFieldGet(this, _Transport_wire, "f").connect(config.address, this.environment.getWsConstructor());
        return this.authorize(config);
    }
    async connectByPort(config) {
        const { address, uuid } = config;
        const reqAuthPayload = { ...config, type: 'file-token' };
        const wire = __classPrivateFieldGet(this, _Transport_wire, "f");
        await wire.connect(address, this.environment.getWsConstructor());
        const requestExtAuthRet = await this.sendAction('request-external-authorization', {
            uuid,
            type: 'file-token'
        }, true);
        if (requestExtAuthRet.action !== 'external-authorization-response') {
            throw new transport_errors_1.UnexpectedActionError(requestExtAuthRet.action);
        }
        await this.environment.writeToken(requestExtAuthRet.payload.file, requestExtAuthRet.payload.token);
        return this.authorize(reqAuthPayload);
    }
    async authorize(reqAuthPayload) {
        const requestAuthRet = await this.sendAction('request-authorization', reqAuthPayload, true);
        if (requestAuthRet.action !== 'authorization-response') {
            throw new transport_errors_1.UnexpectedActionError(requestAuthRet.action);
        }
        else if (requestAuthRet.payload.success !== true) {
            throw new transport_errors_1.RuntimeError(requestAuthRet.payload);
        }
    }
    sendAction(action, payload = {}, uncorrelated = false) {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        let cancel = () => { };
        // We want the callsite from the caller of this function, not from here.
        const callSites = transport_errors_1.RuntimeError.getCallSite(1);
        const messageId = this.environment.getNextMessageId();
        const prom = new Promise((resolve, reject) => {
            cancel = reject;
            const msg = {
                action,
                payload,
                messageId
            };
            const wire = __classPrivateFieldGet(this, _Transport_wire, "f");
            this.addWireListener(messageId, resolve, (payload) => this.nackHandler(payload, reject, callSites), uncorrelated);
            return wire.send(msg).catch(reject);
        });
        return Object.assign(prom, { cancel, messageId });
    }
    nackHandler(payloadOrMessage, reject, callSites) {
        if (typeof payloadOrMessage === 'string') {
            // NOTE: this is for backwards compatibility to support plain string rejections
            reject(payloadOrMessage);
        }
        else {
            reject(new transport_errors_1.RuntimeError(payloadOrMessage, callSites));
        }
    }
    ferryAction(origData) {
        return new Promise((resolve, reject) => {
            const id = this.environment.getNextMessageId();
            origData.messageId = id;
            const resolver = (data) => {
                resolve(data.payload);
            };
            const wire = __classPrivateFieldGet(this, _Transport_wire, "f");
            return wire
                .send(origData)
                .then(() => this.addWireListener(id, resolver, (payload) => this.nackHandler(payload, reject), false))
                .catch(reject);
        });
    }
    registerMessageHandler(handler) {
        this.messageHandlers.push(handler);
    }
    addWireListener(id, resolve, handleNack, uncorrelated) {
        if (uncorrelated) {
            this.uncorrelatedListener = resolve;
        }
        else if (this.wireListeners.has(id)) {
            handleNack({ reason: 'Duplicate handler id', error: (0, errors_1.errorToPOJO)(new transport_errors_1.DuplicateCorrelationError(String(id))) });
        }
        else {
            this.wireListeners.set(id, { resolve, handleNack });
        }
        // Timeout and reject()?
    }
    // This method executes message handlers until the _one_ that handles the message (returns truthy) has run
    onmessage(data) {
        for (const h of this.messageHandlers) {
            h.call(null, data);
        }
    }
    handleMessage(data) {
        const id = data.correlationId || NaN;
        if (!('correlationId' in data)) {
            if (this.uncorrelatedListener) {
                this.uncorrelatedListener.call(null, data);
            }
            this.uncorrelatedListener = () => {
                // empty block
            };
        }
        else if (!this.wireListeners.has(id)) {
            return false;
        }
        else {
            // We just checked for existence above
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { resolve, handleNack } = this.wireListeners.get(id);
            if (data.action !== 'ack') {
                handleNack({ reason: 'Did not receive ack action', error: (0, errors_1.errorToPOJO)(new transport_errors_1.NoAckError(data.action)) });
            }
            else if (!('payload' in data)) {
                // I'm not sure when this code would actually run, but passing in something that doeesn't have a reason to the runtimeerror constructor will not end well.
                // @ts-expect-error
                if (typeof data.reason === 'string') {
                    handleNack(data);
                }
                else {
                    console.warn('Received invalid response from core', data);
                    handleNack({ reason: 'invalid response shape' });
                }
            }
            else if (!data.payload.success) {
                handleNack(data.payload);
            }
            else {
                resolve.call(null, data);
            }
            this.wireListeners.delete(id);
        }
        return true;
    }
}
exports.Transport = Transport;
_Transport_wire = new WeakMap(), _Transport_fin = new WeakMap();
